import React, { useState, useEffect } from 'react'
import { BrowserMultiFormatReader, NotFoundException, BarcodeFormat } from '@zxing/library'
import Webcam from 'react-webcam'
import { Modal } from 'react-bootstrap';
import ScannedItems from './ScannedItems.js';
import {debounce} from 'lodash';
import PropTypes from 'prop-types';

const BarcodeQRScannerComponent = ({onScan, onError, show, onHide, scannedItems=null, multiple_times_allowed=false}) => {
  const [code, setCode] = useState(null)
  const [format, setFormat] = useState(null)
  const [times, setTimes] = useState(1)
  const webcamRef = React.useRef(null)
  const codeReader = new BrowserMultiFormatReader()

  useEffect(() => {
    const capture = () => {
      const imageSrc = webcamRef.current ? webcamRef.current.getScreenshot() : undefined
      if (imageSrc) {
        codeReader.decodeFromImage(undefined, imageSrc).then(result => {
          setCode(result.text)
          setFormat(BarcodeFormat[result.format])
        }).catch((err) => {
          if (err && !(err instanceof NotFoundException)) {
            onError(err)
          }
        })
      }
    }

    const interval = setInterval(capture, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (code !== null && format !== null && times > 0) {
      onScan(code, format, times)
      times === 1 ? clear() : setTimes(1)
    }
  }, [code, format])

  useEffect(() => {
    clear()
  }, [times])

  const clear = debounce(() => {
    setCode(null)
    setFormat(null)
  }, 2000);

  return (
    <div>
      <Modal backdrop="static" keyboard={true} show={show}>
        <Modal.Body className='modalBody'>
          <div className='closeStyle'>
            <button className='btn btn-success' onClick={onHide}>Done</button>
          </div>
          {multiple_times_allowed &&
          <div className={`d-flex justify-content-center ${times < 0 && "has-danger"}`}>
            <div className="input-group-addon">Repeat </div>
            <input className="form-control" type="number" min='1' placeholder="Times" value={times} onChange={(e) => setTimes(e.target.value)} />
          </div>}
          <div className='camStyle'>
            <Webcam
              width={500}
              height={500}
              ref={webcamRef}
              screenshotFormat="image/png"
              videoConstraints={{facingMode: 'environment', audio: false, video: true}}
            />
          </div>
          {scannedItems && scannedItems.length > 0 && <ScannedItems scannedItems={scannedItems}/>}
        </Modal.Body>
      </Modal>
    </div>
  )
}

BarcodeQRScannerComponent.propTypes = {
  onScan: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onError: PropTypes.func,
};

BarcodeQRScannerComponent.defaultProps = {
  onError: (err) => console.error(err)
}

export default BarcodeQRScannerComponent